<template>
    <!--<EZList @click="setActiveEmail($event)" :items="mydrafts" :title="uuid" :subtitle="updatedAt" :icon="'search'" />-->
    <v-list two-line dense>
        <v-list-item v-for="e in emails"
                     :key="e.uuid"
                     @click="(e.uuid===activeid)?$emit('editemail',e):$emit('loademail',e)"
                     color="success"
                     :class="{active:e.uuid===activeid}"
        >
            <v-list-item-content>
                <v-list-item-title :class="{'white--text':e.uuid===activeid}">
                    {{e.subject || 'No Subject'}}
                </v-list-item-title>
                <v-list-item-subtitle :class="{'white--text':e.uuid===activeid}">
                    <span class="font-weight-light text-uppercase" v-if="e.uuid===activeid">
                        Click to Edit
                    </span>
                    <span v-else>
                       {{new Date(e.updatedAt).toLocaleDateString()}}
                       {{new Date(e.updatedAt).toLocaleTimeString()}}
                    </span>

                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="e.uuid===activeid">
                <v-btn icon :class="{'white--text':e.uuid===activeid}">
                    <v-icon>
                        {{icons.edit}}
                    </v-icon>
                </v-btn>
            </v-list-item-action >
            <v-list-item-avatar v-else>
                <v-icon>
                    {{icons.search}}
                </v-icon>
            </v-list-item-avatar >
        </v-list-item>
    </v-list>
</template>
<!-- title="subject" subtitle="updatedAt" icon="search" -->
<script>
  import{
    mapState
  } from 'vuex'
  export default {
    props:['emails','activeid'],
    components: {},
    name: "EmailList",
    data() {
      return {}
    },
    computed:{
      ...mapState(['icons'])
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>
    .active{
        background-color: #2196F3;
        color: white;
    }
</style>